import { forwardRef } from 'react';
import type { ReactNode } from 'react';
import './MessageList.css';

export type MessageListProps = {
  children: ReactNode;
  className?: string;
};

export const MessageList = forwardRef<HTMLDivElement, MessageListProps>(
  ({ children, className = '' }, ref) => {
    return (
      <div ref={ref} className={`message-list ${className}`.trim()}>
        {children}
      </div>
    );
  }
);

MessageList.displayName = 'MessageList';
